import React from 'react'
import mintMid from '../assets/Minting5fps.png'
import mintSide from '../assets/MintingSmall5fps.png'
const mintingGif = require('../assets/Minting gif.gif')

function Mint() {
  return (
    <div className='Mint  border-8 border-[#FFFF7C] rounded-[3rem] bg-[rgba(183,102,95,1)] p-5 w-[70%] drop-shadow-[1px_0px_5px_rgba(244,244,123,1)] lg:p-10 lg:mt-[-20px] flex-grow '>
        
        <div className="mintItems flex justify-center">
            <img src={mintingGif} className='object-contain w-8 sm:w-10 lg:w-40' alt="" />
            <img src={mintingGif} className='object-contain w-12 sm:w-14 lg:w-48' alt="" />
            <img src={mintingGif} className='object-contain w-8 sm:w-10 lg:w-40' alt="" />
        </div>


        <div className="MIDesc mt-10 
        text-[8px] text-white sm:text-[10px] font-early lg:text-[20px]  ">
     
		<span>Each coin plant costs only </span><span className='text-[#7BD98D]'>0.04 ETH</span><span> DURING THE </span><span className='text-[rgba(255,255,124,1)]' >PRESALE</span><span>.ONLY Whitelisted wallet addresses will be able to mint at this price.</span>
        </div>

       <div className="btnWrapper flex justify-center mt-8 lg:mt-20 flex-wrap">
       <div className="mintBtn bg-[gray] text-center px-2 sm:px-8 py-2 rounded-2xl drop-shadow-[0_5px_5px_rgba(0,0,0,0.75)] w-fit cursor-pointer text-white font-early text-[10px] lg:px-20 lg:py-4  ">
            MINT NOW!
        </div>
       </div>

        <div className="mintQty mt-5">
           <span className='text-[rgba(255,255,124,1)] text-[10px] font-early lg:text-[10px]' >0/2500 minted</span>
        </div>
    </div>
  )
}

export default Mint